import { z } from 'zod';

const timeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;

export const time = z
  .string()
  .regex(timeRegex, 'Nesprávný formát, očekávaný HH:mm:ss');

export const dateTime = z.string();

export const date = z.string();

export const month = z.number().min(0).max(11);
